import { LoyaltyCustomer, LoyaltyProduct, LoyaltyProgram, Tier } from "./types";

class AccountLoyalty extends HTMLElement {
  customer?: LoyaltyCustomer;
  loyaltyData?: LoyaltyProgram;
  isLoggedIn = false;
  currentTier?: Tier;
  errorElem?: HTMLElement | null;

  connectedCallback() {
    try {
      this.loyaltyData = JSON.parse(document.querySelector("[data-loyalty-settings]")?.innerHTML);
      this.customer = JSON.parse(this.querySelector("[data-loyalty-customer]")?.innerHTML || "{}");
    } catch (e) {
      console.error(e);
      this.hideComponent();
    }

    this.errorElem = this.querySelector("[data-loyalty-error]");
    this.isLoggedIn = !!this.customer?.id;
    this.currentTier = this.getTier();
    this.displayContent();
  }

  getTier(): Tier | undefined {
    if (!this.isLoggedIn || !this.customer || isNaN(this.customer?.total_spent)) return;
    const { total_spent } = this.customer;

    try {
      return this.loyaltyData?.tiers.find((tier) =>
        tier?.to_threshold
          ? total_spent >= tier.from_threshold && total_spent <= tier.to_threshold
          : total_spent >= tier.from_threshold
      );
    } catch (e) {
      console.error("Loyalty data setup incorrectly, check customiser settings");
      this.hideComponent();
    }
  }

  displayContent() {
    const topImg = this.querySelector("[data-tier-image]");
    const content = this.querySelector("[data-tier-content]");
    const settings = this.loyaltyData?.settings;

    topImg?.setAttribute("src", settings?.image || "");

    if (!content) return this.hideComponent();

    if (!this.isLoggedIn) {
      content.innerHTML = this.renderLoggedOut();
    } else {
      content.innerHTML = `
        ${this.renderTierHtml()}
        ${this.renderRemainingHtml()}
      `;
    }
  }

  renderTierHtml() {
    if (!this.currentTier) return "";
  
    const tiers = this.loyaltyData?.tiers || [];
    const currentIndex = tiers.findIndex((tier) => tier.title === this.currentTier?.title);
    const widthPercentage = tiers.length === 2 ? "55%" : "60%";
  
    return `
      <div class="loyalty-tier-info">
        <div class="loyalty-tier-progress" style="--progress-line-width: ${widthPercentage};">
          ${tiers
            .map(
              (tier, index) => `
                <div class="loyalty-tier-step ${index <= currentIndex ? "completed" : ""}">
                  <div class="icon ${index !== currentIndex ? "small" : ""}">
                    ${
                      index === currentIndex
                        ? `<img src="${tier.icon}" alt="${tier.title}" width="40px" height="40px" />`
                        : ``
                    }
                  </div>
                  <div class="title">
                    <strong>0${index + 1}</strong>
                    <p>${tier.title}</p>
                  </div>
                </div>
              `
            )
            .join("")}
        </div>
      </div>
    `;
  }
  

  renderRemainingHtml() {
    if (!this.currentTier) return "";
    const hasNextTier = !!this.currentTier?.to_threshold;
    let html = this.currentTier.next_tier_content
      ? `<p style="text-align: center;">${this.currentTier.next_tier_content}</p>`
      : "";

    if (hasNextTier && this.customer) {
      const remaining = Math.max(this.currentTier.to_threshold, 0) - this.customer.total_spent + 1;
      html = `<p style="text-align: start;">${
        this.currentTier.next_tier_content?.replace("{amount}", `$${remaining}`) || ""
      }</p>`;
    }

    const additionalLinkHtml = `
    <p style="text-align: start; margin-top: 10px;">
        <a href="${this.loyaltyData?.settings.loyalty_url}" class="underline">Learn more</a>
    </p>
    `;

    return html + additionalLinkHtml;
  }

  renderLoggedOut() {
    return `
      <p class="mb-2">${this.loyaltyData?.settings?.logged_out_content || ""}</p>
      <div class="flex gap-8">
        <a href="/account/register" class="underline">Create Account</a>
        <a href="/account/login" class="underline">Login</a>
      </div>
    `;
  }

  hideComponent() {
    this.classList.add("hidden");
  }
}

customElements.define("account-loyalty", AccountLoyalty);
